<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Categories'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Categories'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'parentCategory.slug',
                    text: 'Parent Category',
                    width: '150px'
                },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                { value: 'name', width: '150px' },
                {
                    text: 'Page Type',
                    value: 'parentCategoryId',
                    width: '150px',
                    sortable: false,
                    filterable: false,
                    filter: 'categoryType'
                },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    text: 'Desktop Hero',
                    value: 'desktopHero',
                    filter: 'getIsHeroImage',
                    type: 'boolean',
                    isBadge: true,
                    width: '150px',
                    sortable: false,
                    filterable: false,
                    skipValue: true,
                    filterOptions: {
                        type: 'image'
                    }
                },
                {
                    text: 'Mobile Hero',
                    value: 'mobileHero',
                    filter: 'getIsHeroImage',
                    type: 'boolean',
                    isBadge: true,
                    width: '150px',
                    sortable: false,
                    filterable: false,
                    skipValue: true,
                    filterOptions: {
                        type: 'mobileImage'
                    }
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    text: 'Created by',
                    value: 'createdBy.fullName',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    text: 'Edited by',
                    value: 'editedBy.fullName',
                    width: '150px'
                },
                {
                    text: 'Full URL',
                    value: 'fullUrl',
                    filter: 'getUrl',
                    width: '150px',
                    skipValue: true,
                    sortable: false,
                    filterable: false,
                    filterOptions: {
                        type: 'category',
                        incudeFullUrl: true
                    }
                },
                {
                    text: 'URL Path',
                    filter: 'getUrl',
                    value: 'urlPath',
                    width: '150px',
                    skipValue: true,
                    sortable: false,
                    filterable: false,
                    filterOptions: {
                        type: 'category'
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'articleCategories/index',
            deleteItem: 'articleCategories/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/article-categories/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/article-categories/add');
        }
    }
};
</script>
